import { render, staticRenderFns } from "./lecture.vue?vue&type=template&id=9853d2e0&scoped=true&"
import script from "./lecture.vue?vue&type=script&lang=js&"
export * from "./lecture.vue?vue&type=script&lang=js&"
import style0 from "./lecture.vue?vue&type=style&index=0&id=9853d2e0&scoped=true&lang=css&"
import style1 from "./lecture.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9853d2e0",
  null
  
)

export default component.exports